import { render, staticRenderFns } from "./SurveyFormErrorsModal.vue?vue&type=template&id=0385feae&scoped=true&"
import script from "./SurveyFormErrorsModal.vue?vue&type=script&lang=js&"
export * from "./SurveyFormErrorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0385feae",
  null
  
)

export default component.exports